import { RegWallListItem } from './RegWallListItem';
export * from './RegWallListItem';
export default RegWallListItem;
